<template>
  <div v-loading="$wait.waiting(_uid)">
    <print-record :user="user" :records="topics" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HelperDate from "@helpers/dates";
import PrintRecord from "@components/Dashboard/Views/Pages/Training/Record/Components/Print";

export default {
  components: {
    PrintRecord,
  },
  data() {
    return {
      topics: [],
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    ...mapGetters("companyUserStore", ["user"]),
    routeQuery() {
      return this.$route.query;
    },
    routeParams() {
      return this.$route.params;
    },
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      const userId = this.routeParams.id;
      await this.getUser(userId);

      const params = {
        userId: this.user.id,
        date: this.parseDate(this.routeQuery.date),
      };

      const records = await this.getUserRecords(params);
      this.topics = records.topics;
    } catch (error) {
      this.addNewError(error);
    } finally {
      setTimeout(window.print, 800);
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("companyUserStore", ["getUser", "getUserRecords"]),
    ...mapActions("errorStore", ["addNewError"]),
    parseDate(date) {
      return HelperDate.formatDate(date);
    },
  },
};
</script>

<style lang="scss" scoped></style>
